module.exports = "//d274d294w9cx2v.cloudfront.net/f4aab9e63e903c3a6af25192d88f9a9c2b48e28a/images/payPalBadge.png";